<template>
  <div class="ellipsis-button">
    <el-popover
      v-model="menu_visible"
      :placement="placement"
      :width="width"
      :open-delay="0"
      trigger="click">
      <template v-if="menu_visible /* fixes performance issue */">
        <button class="ellipsis-button__close close px-2" aria-label="Close" @click="menu_visible = false">
          <span aria-hidden="true">&times;</span>
        </button>

        <div v-if="heading" class="ellipsis-button__heading">{{heading}}</div>

        <template v-for="option in showOptions" v-if="option">

          <el-button
            v-if="option === 'edit'"
            :key="option"
            class="btn-block ml-0"
            size="mini"
            @click.prevent="onHandleMenuAction('edit')">
            <font-awesome-icon
              icon="wrench"
              class="laneicon"
              title="edit lane settings" />
            Edit settings
          </el-button>

          <!--
          <el-button
            v-if="option === 'move'"
            class="btn-block ml-0"
            size="mini"
            @click.prevent="onHandleMenuAction('move')" >
            <font-awesome-icon icon="truck" class="taskicon" />
            Move to another goal
          </el-button>
          -->
          <el-button
            v-if="option === 'rename'"
            :key="option"
            title="Rename"
            class="btn-block ml-0"
            size="mini"
            @click.prevent="onHandleMenuAction('rename')">
            <font-awesome-icon icon="pen-square" class="taskicon" />
            Change name
          </el-button>

          <el-button
            v-if="option === 'restore'"
            :key="option"
            class="btn-block ml-0"
            size="mini"
            @click.prevent="onHandleMenuAction('restore')" type="success" >
            <font-awesome-icon icon="trash-restore-alt" class="taskicon" />
            Restore
          </el-button>

          <el-button
            v-if="option === 'duplicate'"
            :key="option"
            class="btn-block ml-0"
            size="mini"
            @click.prevent="onHandleMenuAction('duplicate')">
            <font-awesome-icon icon="copy" class="taskicon" />
            Duplicate
          </el-button>

          <el-button
            v-if="option === 'archive'"
            :key="option"
            class="btn-block ml-0"
            size="mini"
            @click.prevent="onHandleMenuAction('archive')" type="danger" >
            <font-awesome-icon icon="archive" class="taskicon" />
            Archive
          </el-button>

          <el-button
            v-if="option === 'delete'"
            :key="option"
            class="btn-block ml-0"
            size="mini"
            @click.prevent="onHandleMenuAction('delete')" type="danger" >
            <font-awesome-icon icon="trash-alt" class="taskicon" />
            Permanently delete
          </el-button>

          <slot v-if="option === 'slot'" v-bind:visible="menu_visible" />
        </template>
      </template>

      <el-button slot="reference" class="ellipsis-button__button" :disabled="disabled">
        <font-awesome-icon
          :size="iconSize"
          :icon="icon ? icon : ['fas', 'ellipsis-v']"
          :color="iconColor"
          :class="{ 'mx-2': iconSize === '2x' }" />
      </el-button>
    </el-popover>
  </div>
</template>

<script>
export default {
  props: {
    heading: {
      default: null
    },
    width: {
      default: '200'
    },
    placement: {
      default: 'bottom'
    },
    showOptions: {
      default: ['edit', 'move', 'slot', 'archive', 'delete']
    },
    disabled: {
      default: false
    },
    icon: {
      type: Array
    },
    iconSize: {
      type: String,
      default: 'sm'
    },
    iconColor: {
      type: String,
      default: '#687a8c'
    }
  },
  data: () => ({
    menu_visible: false
  }),
  methods: {
    hide() {
      this.menu_visible = false;
    },
    onHandleMenuAction(action) {
      this.menu_visible = false;
      this.$emit(action)
    }
  }
}
</script>

<style>
.ellipsis-button {
  /*
  font-weight: bold !important;
  border: 1px solid gray !important;
  padding: 0.5em 0.75em !important;
  float: right !important;
  */
}
.ellipsis-button__button::after {
  /* content: "\22ee"; */
}
.ellipsis-button__heading {
  font-weight: bold;
  text-align: center;
  margin-bottom: 5px;
}
.ellipsis-button__button {
  padding: 0.3em 0.75em;
}
.ellipsis-button__close {
  font-size: 1.2rem;
  position: absolute;
  margin: 0;
  top: 0;
  right: 0;
}
.ellipsis-button__close:hover {
  color: black;
}
</style>
